import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import sopHtml from "./sop-content";
import sopOrderProcessingHtml from "./sop-order-processing";

function SOPViewer() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const doc = searchParams.get("doc"); // p2p, order-processing, etc.

  // Select the appropriate SOP content
  const getSopContent = () => {
    switch (doc) {
      case "order-processing":
        return sopOrderProcessingHtml;
      case "p2p":
      default:
        return sopHtml;
    }
  };

  const getTitle = () => {
    switch (doc) {
      case "order-processing":
        return "O2C-OPS Standard – Order Processing Exception Management";
      case "p2p":
      default:
        return "Exception Index – Billing & Meter Exception Classification Reference";
    }
  };

  useEffect(() => {
    document.title = getTitle();
  }, [doc]);

  return (
    <div className="fixed inset-0 w-screen h-screen z-50 bg-white">
      <iframe
        srcDoc={getSopContent()}
        title={getTitle()}
        className="w-full h-full border-0"
        style={{ width: "100vw", height: "100vh" }}
      />
    </div>
  );
}

export default SOPViewer;
